const getCurrentTradingAccount = state => state.authentication.currentTradingAccount;

export default getCurrentTradingAccount;
